module.exports = __webpack_public_path__ + "static/media/206_SHOT_340.748a2647.webp";